module.exports = __webpack_public_path__ + "static/media/civ_eng.7d16d449.png";